<div class="admin-page-container">
  <!-- ── DESKTOP ─────────────────────────────────────────────────────── -->
  <div class="fe-desktop-only">
  <div class="page-header">
    <div class="header-left">
      <h1>User Management</h1>
      <p>Manage Operators, Approvers and their department assignments</p>
    </div>
    <div class="header-right">
      <button class="btn-primary" (click)="openCreateModal()">
        <i class="fa-solid fa-user-plus"></i>
        <span>Create New User</span>
      </button>
    </div>
  </div>

  <div class="dashboard-stats-row">
    <!-- Enhanced Stats Cards -->
    <div class="stat-card">
      <div class="stat-icon bg-blue"><i class="fa-solid fa-users"></i></div>
      <div class="stat-info">
        <span class="label">Total Users</span>
        <span class="value">{{ users().length }}</span>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon bg-purple"><i class="fa-solid fa-user-crown"></i></div>
      <div class="stat-info">
        <span class="label">Admins</span>
        <span class="value">{{ totalAdmins() }}</span>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon bg-indigo"><i class="fa-solid fa-user-tie"></i></div>
      <div class="stat-info">
        <span class="label">Ministers</span>
        <span class="value">{{ totalMinisters() }}</span>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon bg-orange"><i class="fa-solid fa-user-shield"></i></div>
      <div class="stat-info">
        <span class="label">OSDs</span>
        <span class="value">{{ totalOsds() }}</span>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon bg-blue"><i class="fa-solid fa-user-gear"></i></div>
      <div class="stat-info">
        <span class="label">Operators</span>
        <span class="value">{{ totalOperators() }}</span>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon bg-green"><i class="fa-solid fa-user-check"></i></div>
      <div class="stat-info">
        <span class="label">Approvers</span>
        <span class="value">{{ totalApprovers() }}</span>
      </div>
    </div>
  </div>

  <!-- Enhanced Search Bar -->
  <div class="search-section" *ngIf="!loading()">
    <div class="search-container">
      <i class="fa-solid fa-magnifying-glass"></i>
      <input 
        type="text" 
        [value]="searchQuery()" 
        (input)="onSearchChange($event)" 
        placeholder="Search by name, email, role, or department..."
        class="search-input"
      >
      <button 
        class="clear-search" 
        *ngIf="searchQuery()" 
        (click)="searchQuery.set('')"
        title="Clear search"
      >
        <i class="fa-solid fa-times"></i>
      </button>
    </div>
  </div>

  <!-- Enhanced Data Table -->
  <div class="enhanced-table-container">
    <div class="table-header">
      <div class="header-left">
        <h3 class="table-title">System Users</h3>
        <div class="table-actions">
          <button class="btn-export" (click)="exportEnhancedData()" title="Export to Excel">
            <i class="fa-solid fa-file-excel"></i>
            <span>Export All Data</span>
          </button>
        </div>
      </div>
      <div class="header-right">
        <div class="view-toggle">
          <label class="switch-label">
            <input type="checkbox" [ngModel]="showInactiveUsers()" (ngModelChange)="showInactiveUsers.set($event)" (change)="updateFilteredUsers()">
            <span>Show Inactive Users</span>
          </label>
        </div>
      </div>
    </div>

    <!-- Tabular View -->
    <div class="tabular-view">
      <div class="table-wrapper">
        <table class="enhanced-data-table">
          <thead>
            <tr>
              <th class="th-sl sortable" (click)="sortBy('displayName')">
                <span class="th-content">SL</span>
                <i class="fa-solid fa-sort" *ngIf="sortField() !== 'displayName'"></i>
                <i class="fa-solid fa-sort-up" *ngIf="sortField() === 'displayName' && sortDirection() === 'asc'"></i>
                <i class="fa-solid fa-sort-down" *ngIf="sortField() === 'displayName' && sortDirection() === 'desc'"></i>
              </th>
              <th class="th-name sortable" (click)="sortBy('displayName')">
                <span class="th-content">Full Name</span>
                <i class="fa-solid fa-sort" *ngIf="sortField() !== 'displayName'"></i>
                <i class="fa-solid fa-sort-up" *ngIf="sortField() === 'displayName' && sortDirection() === 'asc'"></i>
                <i class="fa-solid fa-sort-down" *ngIf="sortField() === 'displayName' && sortDirection() === 'desc'"></i>
              </th>
              <th class="th-email sortable" (click)="sortBy('email')">
                <span class="th-content">Email</span>
                <i class="fa-solid fa-sort" *ngIf="sortField() !== 'email'"></i>
                <i class="fa-solid fa-sort-up" *ngIf="sortField() === 'email' && sortDirection() === 'asc'"></i>
                <i class="fa-solid fa-sort-down" *ngIf="sortField() === 'email' && sortDirection() === 'desc'"></i>
              </th>
              <th class="th-role sortable" (click)="sortBy('role')">
                <span class="th-content">Role</span>
                <i class="fa-solid fa-sort" *ngIf="sortField() !== 'role'"></i>
                <i class="fa-solid fa-sort-up" *ngIf="sortField() === 'role' && sortDirection() === 'asc'"></i>
                <i class="fa-solid fa-sort-down" *ngIf="sortField() === 'role' && sortDirection() === 'desc'"></i>
              </th>
              <th class="th-departments">Departments</th>
              <th class="th-blocks">Block / NAC</th>
              <th class="th-mobile sortable" (click)="sortBy('mobileNumber')">
                <span class="th-content">Mobile</span>
                <i class="fa-solid fa-sort" *ngIf="sortField() !== 'mobileNumber'"></i>
                <i class="fa-solid fa-sort-up" *ngIf="sortField() === 'mobileNumber' && sortDirection() === 'asc'"></i>
                <i class="fa-solid fa-sort-down" *ngIf="sortField() === 'mobileNumber' && sortDirection() === 'desc'"></i>
              </th>
              <th class="th-status sortable" (click)="sortBy('isActive')">
                <span class="th-content">Status</span>
                <i class="fa-solid fa-sort" *ngIf="sortField() !== 'isActive'"></i>
                <i class="fa-solid fa-sort-up" *ngIf="sortField() === 'isActive' && sortDirection() === 'asc'"></i>
                <i class="fa-solid fa-sort-down" *ngIf="sortField() === 'isActive' && sortDirection() === 'desc'"></i>
              </th>
              <th class="th-created sortable" (click)="sortBy('createdAt')">
                <span class="th-content">Created</span>
                <i class="fa-solid fa-sort" *ngIf="sortField() !== 'createdAt'"></i>
                <i class="fa-solid fa-sort-up" *ngIf="sortField() === 'createdAt' && sortDirection() === 'asc'"></i>
                <i class="fa-solid fa-sort-down" *ngIf="sortField() === 'createdAt' && sortDirection() === 'desc'"></i>
              </th>
              <th class="th-last-login sortable" (click)="sortBy('lastLogin')">
                <span class="th-content">Last Login</span>
                <i class="fa-solid fa-sort" *ngIf="sortField() !== 'lastLogin'"></i>
                <i class="fa-solid fa-sort-up" *ngIf="sortField() === 'lastLogin' && sortDirection() === 'asc'"></i>
                <i class="fa-solid fa-sort-down" *ngIf="sortField() === 'lastLogin' && sortDirection() === 'desc'"></i>
              </th>
              <th class="th-actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of paginatedUsers(); let i = index">
                <td class="td-sl">{{ i + 1 }}</td>
                <td class="td-name">
                  <div class="user-info">
                    <div class="user-name">{{ user.displayName }}</div>
                    <div class="user-email">{{ user.email }}</div>
                  </div>
                </td>
                <td class="td-email">{{ user.email }}</td>
                <td class="td-role">
                  <span class="role-badge" [ngClass]="getRoleClass(user.role)">{{ user.role }}</span>
                </td>
                <td class="td-departments">
                  <div class="dept-list">
                    <span *ngFor="let deptId of user.departmentIds" class="dept-chip">{{ getDepartmentName(deptId) }}</span>
                  </div>
                </td>
                <td class="td-blocks" [title]="user.blockAccess?.join(', ') || ''">{{ blocksSummary(user) }}</td>
                <td class="td-mobile">{{ user.mobileNumber || '—' }}</td>
                <td class="td-status">
                  <span class="status-badge" [ngClass]="getStatusClass(user)">{{ user.isActive ? 'Active' : 'Inactive' }}</span>
                </td>
                <td class="td-created">{{ formatDate(user.createdAt) }}</td>
                <td class="td-last-login">{{ user.lastLogin ? formatDate(user.lastLogin) : 'Never' }}</td>
                <td class="td-actions">
                  <div class="action-buttons">
                    <button class="btn-icon edit" (click)="openEditModal(user)" title="Edit User">
                      <i class="fa-solid fa-pen-to-square"></i>
                    </button>
                    <button class="btn-icon delete" (click)="openDeleteModal(user)" title="Delete User">
                      <i class="fa-solid fa-trash-can"></i>
                    </button>
                  </div>
                </td>
              </tr>
          </tbody>
        </table>
      </div>
    </div>

    
    <!-- Pagination -->
    <div class="pagination-controls">
      <div class="pagination-info">
        <span>Showing {{ startIndex() + 1 }}-{{ Math.min(endIndex(), filteredUsers().length) }} of {{ filteredUsers().length }} users</span>
      </div>
      <div class="pagination-buttons">
        <button class="btn-pagination" (click)="previousPage()" [disabled]="currentPage() === 1">
          <i class="fa-solid fa-chevron-left"></i>
        </button>
        <div class="page-numbers">
          <button *ngFor="let page of totalPages()" class="btn-page" [class.active]="page === currentPage()" (click)="goToPage(page)">{{ page }}</button>
        </div>
        <button class="btn-pagination" (click)="nextPage()" [disabled]="currentPage() === totalPages().length">
          <i class="fa-solid fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>

  </div><!-- /fe-desktop-only -->

  <!-- ── MOBILE: Admin user management ───────────────────────────────── -->
  <div class="fe-mobile-only um-mobile-stack">

    <div class="um-m-topbar">
      <div class="um-m-topbar-text">
        <h1>User Management</h1>
        <p>Operators, Approvers &amp; roles</p>
      </div>
      <button type="button" class="um-m-create-btn" (click)="openCreateModal()" aria-label="Create new user">
        <i class="fa-solid fa-user-plus"></i>
      </button>
    </div>

    @if (currentUser(); as me) {
      <section class="um-m-profile-card" aria-label="Your admin profile">
        <div class="um-m-avatar" aria-hidden="true">{{ profileUi.avatarInitial(me) }}</div>
        <div class="um-m-profile-body">
          <span class="um-m-profile-name">{{ profileUi.displayName(me) }}</span>
          <span class="um-m-profile-title">{{ profileUi.designation(me) }}</span>
          <span class="um-m-profile-role">{{ profileUi.roleBadge(me) }}</span>
        </div>
        <div class="um-m-profile-meta">
          <span class="um-m-meta-lbl">Signed in</span>
          <span class="um-m-meta-val">{{ me.email }}</span>
        </div>
      </section>
    }

    <div class="um-m-kpi-row">
      <button type="button"
              class="um-m-kpi total"
              [class.active]="!roleFilter()"
              (click)="setRoleFilter('')"
              aria-label="All users">
        <i class="fa-solid fa-users"></i>
        <span class="um-m-kpi-val">{{ users().length }}</span>
        <span class="um-m-kpi-lbl">Total</span>
      </button>
      <button type="button"
              class="um-m-kpi operators"
              [class.active]="roleFilter() === 'operator'"
              (click)="setRoleFilter('operator')"
              aria-label="Operators">
        <i class="fa-solid fa-user-gear"></i>
        <span class="um-m-kpi-val">{{ totalOperators() }}</span>
        <span class="um-m-kpi-lbl">Operators</span>
      </button>
      <button type="button"
              class="um-m-kpi approvers"
              [class.active]="roleFilter() === 'approver'"
              (click)="setRoleFilter('approver')"
              aria-label="Approvers">
        <i class="fa-solid fa-user-check"></i>
        <span class="um-m-kpi-val">{{ totalApprovers() }}</span>
        <span class="um-m-kpi-lbl">Approvers</span>
      </button>
      <button type="button"
              class="um-m-kpi admins"
              [class.active]="roleFilter() === 'admin'"
              (click)="setRoleFilter('admin')"
              aria-label="Admins">
        <i class="fa-solid fa-user-shield"></i>
        <span class="um-m-kpi-val">{{ totalAdmins() }}</span>
        <span class="um-m-kpi-lbl">Admins</span>
      </button>
    </div>

    <div class="um-m-filters">
      <div class="um-m-search">
        <i class="fa-solid fa-magnifying-glass"></i>
        <input type="search"
               [value]="searchQuery()"
               (input)="onSearchChange($event)"
               placeholder="Search name, email, role..." />
        @if (searchQuery()) {
          <button type="button" class="um-m-search-clear" (click)="searchQuery.set(''); currentPage.set(1)" aria-label="Clear search">
            <i class="fa-solid fa-xmark"></i>
          </button>
        }
      </div>
      <label class="um-m-inactive-toggle">
        <input type="checkbox"
               [ngModel]="showInactiveUsers()"
               (ngModelChange)="showInactiveUsers.set($event); updateFilteredUsers()">
        <span>Show inactive users</span>
      </label>
    </div>

    <div class="um-m-actions-row">
      <h3 class="um-m-section-title">Users ({{ filteredUsers().length }})</h3>
      <button type="button" class="um-m-export-btn" (click)="exportEnhancedData()" title="Export to Excel">
        <i class="fa-solid fa-file-excel"></i>
      </button>
    </div>

    @if (loading()) {
      <div class="um-m-loading">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <span>Loading users…</span>
      </div>
    } @else if (paginatedUsers().length === 0) {
      <div class="um-m-empty">
        <i class="fa-solid fa-users-slash"></i>
        <p>No users found</p>
        <span>Try adjusting search or filters</span>
        @if (searchQuery() || roleFilter()) {
          <button type="button" class="um-m-empty-btn" (click)="searchQuery.set(''); setRoleFilter('')">Clear filters</button>
        }
      </div>
    } @else {
      <div class="um-m-user-list">
        @for (user of paginatedUsers(); track user.uid) {
          <article class="um-m-user-card" [class.inactive]="!user.isActive">
            <div class="um-m-user-head">
              <div class="um-m-user-identity">
                <h4 class="um-m-user-name">{{ user.displayName }}</h4>
                <p class="um-m-user-email">{{ user.email }}</p>
              </div>
              <span class="role-badge" [ngClass]="getRoleClass(user.role)">{{ formatRoleLabel(user.role) }}</span>
            </div>

            <div class="um-m-user-meta">
              <div class="um-m-meta-item">
                <i class="fa-solid fa-phone"></i>
                <span>{{ user.mobileNumber || '—' }}</span>
              </div>
              <div class="um-m-meta-item">
                <i class="fa-solid fa-building"></i>
                <span>{{ departmentsSummary(user) }}</span>
              </div>
              <div class="um-m-meta-item" *ngIf="user.blockAccess?.length">
                <i class="fa-solid fa-map-location-dot"></i>
                <span>{{ blocksSummary(user) }}</span>
              </div>
            </div>

            <div class="um-m-user-foot">
              <span class="status-badge" [ngClass]="getStatusClass(user)">{{ user.isActive ? 'Active' : 'Inactive' }}</span>
              <span class="um-m-last-login">
                <i class="fa-regular fa-clock"></i>
                {{ user.lastLogin ? formatDate(user.lastLogin) : 'Never logged in' }}
              </span>
              <div class="um-m-card-actions">
                <button type="button" class="um-m-act edit" (click)="openEditModal(user)" aria-label="Edit user">
                  <i class="fa-solid fa-pen-to-square"></i>
                </button>
                <button type="button" class="um-m-act delete" (click)="openDeleteModal(user)" aria-label="Delete user">
                  <i class="fa-solid fa-trash-can"></i>
                </button>
              </div>
            </div>
          </article>
        }
      </div>

      @if (filteredUsers().length > 0) {
        <div class="um-m-pagination">
          <span class="um-m-page-info">
            {{ startIndex() + 1 }}–{{ Math.min(endIndex(), filteredUsers().length) }} of {{ filteredUsers().length }}
          </span>
          <div class="um-m-page-btns">
            <button type="button" class="um-m-page-btn" (click)="previousPage()" [disabled]="currentPage() === 1" aria-label="Previous page">
              <i class="fa-solid fa-chevron-left"></i>
            </button>
            <span class="um-m-page-num">{{ currentPage() }} / {{ totalPages().length || 1 }}</span>
            <button type="button" class="um-m-page-btn" (click)="nextPage()" [disabled]="currentPage() === totalPages().length || totalPages().length === 0" aria-label="Next page">
              <i class="fa-solid fa-chevron-right"></i>
            </button>
          </div>
        </div>
      }
    }

  </div><!-- /fe-mobile-only -->

  </div>

<!-- Create/Edit User Modal -->
<app-admin-modal
  [isOpen]="isModalOpen()"
  [title]="editingUser ? 'Edit User' : 'Create New User'"
  [subtitle]="editingUser ? 'Update account details and permissions' : 'Add a new Operator or Approver to the system'"
  [icon]="editingUser ? 'fa-solid fa-user-pen' : 'fa-solid fa-user-plus'"
  [submitText]="editingUser ? 'Update User' : 'Create User'"
  [isSubmitting]="isSubmitting()"
  (close)="isModalOpen.set(false); closeBlockMenu()"
  (submit)="submitForm()"
>
  <form [formGroup]="userForm" class="admin-form">
    <div class="form-grid">
      <div class="form-group full" [class.error]="userForm.get('displayName')?.invalid && userForm.get('displayName')?.touched">
        <label>Full Name</label>
        <div class="input-wrap">
          <i class="fa-solid fa-user"></i>
          <input type="text" formControlName="displayName" placeholder="Enter full name" autocomplete="off">
        </div>
        <span class="error-text" *ngIf="userForm.get('displayName')?.invalid && userForm.get('displayName')?.touched">Required (min 3 chars)</span>
      </div>

      <div class="form-group" [class.error]="userForm.get('email')?.invalid && userForm.get('email')?.touched">
        <label>Email Address</label>
        <div class="input-wrap">
          <i class="fa-solid fa-envelope"></i>
          <input type="email" formControlName="email" placeholder="email@example.com" autocomplete="off">
        </div>
        <span class="error-text" *ngIf="userForm.get('email')?.invalid && userForm.get('email')?.touched">Valid email required</span>
      </div>

      <div class="form-group" [class.error]="userForm.get('mobileNumber')?.invalid && userForm.get('mobileNumber')?.touched">
        <label>Mobile Number</label>
        <div class="input-wrap">
          <i class="fa-solid fa-phone"></i>
          <input type="text" formControlName="mobileNumber" placeholder="10-digit number" autocomplete="off">
        </div>
        <span class="error-text" *ngIf="userForm.get('mobileNumber')?.invalid && userForm.get('mobileNumber')?.touched">10 digits required</span>
      </div>

      <div class="form-group role-block-row" [class.error]="userForm.get('role')?.invalid && userForm.get('role')?.touched">
        <label>Role</label>
        <div class="input-wrap">
          <i class="fa-solid fa-user-shield"></i>
          <select formControlName="role">
            <option value="admin">Admin</option>
            <option value="minister">Minister</option>
            <option value="osd">OSD</option>
            <option value="operator">Operator</option>
            <option value="approver">Approver</option>
          </select>
        </div>
        <span class="error-text" *ngIf="userForm.get('role')?.invalid && userForm.get('role')?.touched">Please select a role</span>
      </div>

      <div class="form-group role-block-access-col"
           *ngIf="userForm.get('role')?.value !== 'osd' && userForm.get('role')?.value !== 'admin' && userForm.get('role')?.value !== 'minister'"
           [class.error]="userForm.hasError('blockAccessRequired') && userForm.touched">
        <label>Block / NAC Access</label>
        <div class="um-block-ms" [class.is-open]="isBlockMenuOpen()" (click)="$event.stopPropagation()">
          <button type="button"
                  class="um-block-trigger"
                  [class.has-selection]="selectedBlockCount() > 0"
                  (click)="toggleBlockMenu($event)"
                  aria-haspopup="listbox"
                  [attr.aria-expanded]="isBlockMenuOpen()">
            <i class="fa-solid fa-location-dot um-block-icon"></i>
            <span class="um-block-label">{{ blockAccessSelectionLabel() }}</span>
            <span class="um-block-count" *ngIf="selectedBlockCount() > 0">{{ selectedBlockCount() }}</span>
            <i class="fa-solid fa-caret-down um-block-caret"></i>
          </button>
          <div class="um-block-panel" *ngIf="isBlockMenuOpen()" (click)="$event.stopPropagation()">
            <div class="um-block-toolbar">
              <button type="button" class="um-block-link" (click)="selectAllBlocks()">Select all</button>
              <button type="button" class="um-block-link muted"
                      (click)="clearBlockSelection()"
                      [disabled]="selectedBlockCount() === 0">Clear</button>
            </div>
            <ul class="um-block-list" role="listbox">
              <li *ngFor="let loc of masterLocations()">
                <label class="um-block-item">
                  <input type="checkbox"
                         [checked]="isBlockSelected(loc.name)"
                         (change)="toggleBlockSelection(loc.name)" />
                  <span class="um-block-name">{{ loc.name }}</span>
                  <span class="um-block-type">{{ loc.type }}</span>
                </label>
              </li>
              <li class="um-block-empty" *ngIf="masterLocations().length === 0">No locations available</li>
            </ul>
            <div class="um-block-footer">
              <button type="button" class="um-block-done" (click)="closeBlockMenu()">Done</button>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group full section-divider" *ngIf="userForm.get('role')?.value !== 'osd' && userForm.get('role')?.value !== 'admin' && userForm.get('role')?.value !== 'minister'">
        <label>Department Access</label>
        <div class="multi-select-wrap">
          <div class="dept-chips custom-scroll">
             <label *ngFor="let dept of departments()" class="dept-chip">
               <input type="checkbox" [value]="dept.id"
                      [checked]="isDepartmentSelected(dept.id)"
                      (change)="toggleDepartmentSelection(dept.id)">
               <span>{{ dept.name }}</span>
             </label>
          </div>
        </div>
        <small class="form-help">Select departments this user can access. Operators and Approvers need department assignments.</small>
      </div>

      <div class="form-group" [class.error]="userForm.get('password')?.invalid && userForm.get('password')?.touched">
        <label>{{ editingUser ? 'New Password' : 'Password' }}</label>
        <div class="input-wrap">
          <i class="fa-solid fa-lock"></i>
          <input type="password" formControlName="password" placeholder="••••••••" autocomplete="new-password">
        </div>
        <span class="error-text" *ngIf="userForm.get('password')?.invalid && userForm.get('password')?.touched">Min 6 chars</span>
        <small class="form-help" *ngIf="editingUser">Leave blank to keep the current password.</small>
      </div>

      <div class="form-group" [class.error]="userForm.get('status')?.invalid && userForm.get('status')?.touched">
        <label>Status</label>
        <div class="input-wrap">
          <i class="fa-solid fa-toggle-on"></i>
          <select formControlName="status">
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
            <option value="suspended">Suspended</option>
          </select>
        </div>
        <span class="error-text" *ngIf="userForm.get('status')?.invalid && userForm.get('status')?.touched">Please select a status</span>
      </div>

      <div class="form-group full">
        <label>Remarks</label>
        <textarea formControlName="remarks" rows="2" placeholder="Optional notes..."></textarea>
      </div>
    </div>
  </form>
</app-admin-modal>

<!-- Delete Confirmation Modal -->
<app-admin-modal
  [isOpen]="isDeleteModalOpen()"
  [title]="'Delete User Permanently'"
  [subtitle]="'This action cannot be undone. The user will be permanently removed from the system.'"
  [icon]="'fa-solid fa-triangle-exclamation'"
  [submitText]="'Delete Permanently'"
  [isSubmitting]="isDeleting()"
  [submitClass]="'danger'"
  (close)="isDeleteModalOpen.set(false)"
  (submit)="confirmDelete()"
>
  <div class="delete-confirmation">
    <div class="warning-message">
      <i class="fa-solid fa-exclamation-triangle"></i>
      <p>Are you sure you want to permanently delete this user?</p>
    </div>
    <div class="user-details" *ngIf="userToDelete()">
      <p><strong>Name:</strong> {{ userToDelete()?.displayName }}</p>
      <p><strong>Email:</strong> {{ userToDelete()?.email }}</p>
      <p><strong>Role:</strong> {{ userToDelete()?.role }}</p>
    </div>
    <div class="warning-list">
      <ul>
        <li>User will be removed from all collections</li>
        <li>All permissions will be revoked</li>
        <li>Dashboard access will be disabled</li>
        <li>This action cannot be undone</li>
      </ul>
    </div>
  </div>
</app-admin-modal>
